import {
  RedoOutlined,
  UploadOutlined,
  VideoCameraAddOutlined,
} from "@ant-design/icons";
import { useGetGettyImageVideos } from "../../../../api/gettyImages/getGettyImageVideo";
import { useGetGettyImages } from "../../../../api/gettyImages/getGettyImages";
import { useGetPexelsVideos } from "../../../../api/pexels/getPexelsVideo";
import { useGetAssets } from "../../../../api/useGetAssets";
import { PEXELS_KEY, PIXABY_KEY, IS_FREE_PLATFORM } from "../../../../config";
import { qaBackendApiInstance, getDomainID } from "../../../../config/config";
import { useGlobalContext } from "../../../../context/globalContext";
import { Button, Input, Tabs, message, Collapse, Select } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { observer } from "mobx-react-lite";
import { SectionTab } from "polotno/side-panel";
import { useCallback, useEffect, useRef, useState } from "react";
import { VideoSearch } from "../videoSearchResultTwo";
import { v4 as uuidv4 } from "uuid";
import { useGetAiImages } from "../../../../api/useAiImageAssets";
import { generateUniqueId } from "../../../../shared/utils/core";
import {
  Alignment,
  Button as BlueprintButton,
  Navbar,
} from "@blueprintjs/core";
import { aiImagesAPI } from "@src/shared/utils/VideoGeneration/helperFunctions/mediaSearch";
import TextArea from "antd/es/input/TextArea";
import { useFileUploadServer } from "@src/api/videoUpload/useFileUploadServer";
import { Video02Icon } from "../hugeIcons/hugeIcons";
import useGetAroleAssets from "@src/api/useGetARoleAssts";
import { useMultiPartServerS3 } from "@src/api/useMultiparts3Upload";
import { getImagesFromWebsites } from "@src/api/fetchImagesFromWebsites";
import './customVideoSearchPanelTwo.less';

const { Panel } = Collapse;

interface VideoPanelProps {
  store: any;
  elementID: string;
  index: number;
  isNotPanel?: boolean;
  searchQueries: string[];
  subIndex?: number;
  searchQueriesFromParent?: string[];

}

function getType(file: any) {
  const { type } = file;
  if (type.indexOf("svg") >= 0) {
    return "svg";
  }
  if (type.indexOf("image") >= 0) {
    return "image";
  }
  if (type.indexOf("video") >= 0) {
    return "video";
  }
  if (type.indexOf("audio") >= 0) {
    return "audio";
  }
  return "image";
}

export const VideoPanel = observer(
  ({ store, isNotPanel = true, searchQueriesFromParent = [] }: VideoPanelProps) => {
    const {
      ScriptDetails: [scriptDetails],
      UserDetail: [userDetails, setUserDetails],
      ActiveIndex: [activeIndex, setActiveIndex],
      ActiveElementId: [activeElementId, setActiveElementId],
      ActiveSearchQueries: [activeSearchQueries, setActiveSearchQueries],
      ActiveSidePanel: [, setActiveSidePanel],
    } = useGlobalContext();

    useEffect(() => {
      setActiveSidePanel(store.openedSidePanel);
    }, []);
    //   const index=activeIndex
    // console.log(elementID, index, isNotPanel, searchQueries)
    const [index, setIndex] = useState(activeIndex);
    const [elementID, setElementID] = useState(activeElementId);
    const [searchQueries, setSearchQueries] = useState(activeSearchQueries);

    const [searchQueryIndex, setSearchQueryIndex] = useState(0);
    const [imagePage, setImagePage] = useState(1);
    const [videoPage, setVideoPage] = useState(1);
    const [isUploading, setUploading] = useState(false);
    const [images, setImages] = useState<any>([]);
    const [videos, setVideos] = useState<any>([]);
    const [activeTabKey, setActiveTabKey] = useState("0");
    const [aiImageGenerating, setAiImageGenerating] = useState(false);
    const [type, setType] = useState("image");
    const [transformedVideos, setTransformedVideos] = useState<any[]>([]);
    const { uploadImage: uploadToServer } = useMultiPartServerS3();
    const [progress, setProgress] = useState<number | null>(null);
    const [
      transformedGettyImageVideos,
      setTransformedGettyImageVideos,
    ] = useState<any[]>([]);
    const [transformedGettyImages, setTransformedGettyImages] = useState<any[]>(
      []
    );

    const [selectedOrientationValue, setSelectedOrientationValue] = useState(
      userDetails?.purpose?.size === "9:16" ? "vertical" : "horizontal"
    );

    useEffect(() => {
      setSelectedOrientationValue(
        userDetails?.purpose?.size === "9:16" ? "vertical" : "horizontal"
      );
    }, [userDetails]);
    const [uploadingVideo, setUploadingVideo] = useState(false);

    // const { data:assetStatus, isLoading:isAsseStatusLoading, error:assetStatusError } = useGetAssetStatus(taskId || "",
    //   isPollingEnabled ? 5000 : undefined );

    
    const [transformedAIImage, setTransformedAIImage] = useState<
      { id: string; image_url: any; video_url: any; type: string }[]
    >([]);
    
    // Website fetching state
    const [websiteUrl, setWebsiteUrl] = useState('');
    const [isWebsiteFetching, setIsWebsiteFetching] = useState(false);
    const [transformedWebsiteAssets, setTransformedWebsiteAssets] = useState<
      { id: string; image_url: any; video_url: any; type: string }[]
    >([]);

    // Update website state when userDetails changes
    useEffect(() => {
      if (userDetails?.purpose?.fetchedWebsite) {
        setWebsiteUrl(userDetails.purpose.fetchedWebsite);
      }
      if (userDetails?.purpose?.websitesImages) {
        setTransformedWebsiteAssets(userDetails.purpose.websitesImages);
      }
    }, [userDetails]);

    const handleTabChange = (key: any) => {
      setActiveTabKey(key);
    };

    const generateAiImage = async () => {
      setAiImageGenerating(true);
      try {
        const aiImage = await aiImagesAPI(
          debouncedSearchQuery,
          selectedOrientationValue,
          userDetails?.purpose?.aiImagePrefix || ""
        );
        const newImage = {
          id: generateUniqueId(),
          image_url: aiImage,
          video_url: aiImage,
          type: "image",
        };
        // transformedAIImage = [{id: generateUniqueId(), image_url:aiImage, video_url:aiImage, type:'image'}]
        // const addImage = (newImage: { id: string; image_url: any; video_url: any; type: string }) => {
        setTransformedAIImage((prevImages) => [...prevImages, newImage]);
        // };
      } catch (error) {
        console.error(error);
      } finally {
        setAiImageGenerating(false);
      }
    };
    
    const fetchWebsiteAssets = async () => {
      setIsWebsiteFetching(true);
      const originalUrl = websiteUrl; // Store original URL for display
      try {
        const data = await getImagesFromWebsites(websiteUrl);
        
        // Transform API response to match expected format
        const transformedAssets = (data?.images || []).map((item: any) => ({
          id: generateUniqueId(),
          image_url: item,
          video_url: null,
          type: 'image',
        }));
        
        // Update userDetails.purpose with fetched images and website URL
        setUserDetails((prev: any) => ({
          ...prev,
          purpose: {
            ...prev.purpose,
            websitesImages: [...transformedAssets, ...(prev.purpose?.websitesImages || [])],
            fetchedWebsite: data.originalUrl || originalUrl,
          },
        }));
        
        setTransformedWebsiteAssets((prevAssets) => [...transformedAssets, ...prevAssets]);
        // Use the properly formatted URL from API response
        const displayUrl = data.originalUrl || originalUrl;
        message.success(`Fetched ${transformedAssets.length} assets from ${displayUrl}`);
      } catch (error: any) {
        console.error('Error fetching website assets from:', originalUrl, error);
        
        // Handle specific validation errors
        if (error.message === 'URL is required') {
          message.error('Please enter a website URL');
        } else if (error.message === 'Invalid URL format') {
          message.error('Please enter a valid URL (e.g., nike.com or https://nike.com)');
        } else if (error.message === 'Invalid domain format') {
          message.error('Please enter a valid domain name');
        } else {
          message.error('Failed to fetch website assets. Please check the URL and try again.');
        }
      } finally {
        setIsWebsiteFetching(false);
      }
    };
    
    function getExtension(filename: any) {
      return filename.split(".").pop();
    }
    const handleFileInput = async (e: any) => {
      const { target } = e;
      setUploading(true);
      for (const file of target.files) {
        // await uploadFile(file);
        const asset_name = file.name.split('.');
        await uploadToServer(file, asset_name[0], (progress) => {
      
        setProgress(progress)
        });
      }
      setProgress(null)
      refetchAroleAssets()

      setUploading(false);
      target.value = null;
    };

    const [searchQuery, setSearchQuery] = useState(
      scriptDetails?.data[store?.activePage?.custom?.scriptIndex]
        ?.searchQueries[index] || activeSearchQueries
        ? activeSearchQueries?.[0]
        : scriptDetails.data?.[0].searchQueries?.[searchQueryIndex] ||
            store?.activePage?.custom?.searchQuery ||
            ""
    );
    useEffect(() => {
      const ImageIndex =
        store?.activePage?.custom?.imageIndex <=
        scriptDetails?.data[store?.activePage?.custom?.scriptIndex]
          ?.searchQueries?.length -
          1
          ? store?.activePage?.custom?.imageIndex
          : 0;

      setSearchQuery(
        scriptDetails?.data[store?.activePage?.custom?.scriptIndex]
          ?.searchQueries[ImageIndex] || activeSearchQueries
          ? activeSearchQueries?.[0]
          : scriptDetails.data?.[0].searchQueries?.[searchQueryIndex] ||
              store?.activePage?.custom?.searchQuery ||
              ""
      );
    }, [store?.activePage]);
    useEffect(() => {
      const index =
        store?.activePage?.custom?.imageIndex <
        scriptDetails?.data[store?.activePage?.custom?.scriptIndex]
          ?.searchQueries?.length
          ? store?.activePage?.custom?.imageIndex
          : 0;
      setSearchQuery(
        scriptDetails?.data[store?.activePage?.custom?.scriptIndex]
          ?.searchQueries[index] || ""
      );
    }, [activeSearchQueries]);
    const debouncedSearchQuery = useDebounce<string>(searchQuery, 500); // Debounce search input to reduce API calls

    useEffect(() => {
    
      if(searchQueriesFromParent.length > 0){
        setTransformedGettyImageVideos([]);
        setTransformedGettyImages([]);

        setSearchQuery(searchQueriesFromParent[0]);
       
      }
    }, [searchQueriesFromParent]);

    const { data: pexelsVideos, isLoading } = useGetPexelsVideos(
      PEXELS_KEY,
      debouncedSearchQuery, // Use the debounced query value
      "landscape",
      "medium"
    );

    const {
      data: imageData,
      isLoading: isImagesLoading,
      isError,
      isSuccess: isImagesSuccess,
      refetch: refetchImages,
    } = useGetAssets(imagePage, "image");

    const { data:aRoleAssets, isLoading:aRoleLoading, isFetching:aRoleFetching, fetchNextPage:aRolefetchNextPage, hasNextPage:aRoleHasNextPage, refetch:refetchAroleAssets} = useGetAroleAssets(type);
    useEffect(() => {
      if (aRoleAssets?.items) {
        const transformed = aRoleAssets.items.map((item: any) => ({
          id: item.id,
          image_url: item.media_url,
          video_url: item.media_url,
          type: item.type
        }));
        if (JSON.stringify(transformed) !== JSON.stringify(transformedVideos)) {
          setTransformedVideos(transformed);
        }
        // setTransformedVideos(transformed);
      }
    }, [aRoleAssets]);

    const handleImageLoadMore = () => {
      setImagePage(imagePage + 1);
    };

    const handleVideoLoadMore = () => {
      setVideoPage(videoPage + 1);
      aRolefetchNextPage()
    };



    const {
      data: gettyImageVideos,
      isLoading: isGettyImageVideoLoading,
      isSuccess: isGettyImageVideosSuccess,
      page: gettyVideoPage,
      setPage: setGettyVideoPage,
    } = useGetGettyImageVideos(
      searchQuery,
      userDetails?.purpose?.size,
      selectedOrientationValue,
      15,
      1,
      userDetails?.purpose?.videotechniques || []
    );

    useEffect(() => {
      if (isGettyImageVideosSuccess && gettyImageVideos?.videos) {
        const newVideos = gettyImageVideos.videos.map((video: any) => {
          const videoPreview = video.display_sizes.find(
            (displaySize: any) => displaySize.name === "preview_1"
          );
          const imagePreview = video.display_sizes.find(
            (displaySize: any) => displaySize.name === "thumb"
          );

          return {
            id: video.id,
            image_url: imagePreview?.uri || "",
            video_url: videoPreview?.uri || "",
            type: "video",
          };
        });

        // Append new videos to existing state
        setTransformedGettyImageVideos((prevVideos) => [
          ...prevVideos,
          ...newVideos,
        ]);
      }
    }, [isGettyImageVideosSuccess, gettyImageVideos]);


    const {
      data: gettyImages,
      isLoading: isGettyImagesLoading,
      isSuccess: isGettyImagesSuccess,
      page: gettypageNumber,
      setPage: setGettyPageNumber,
    } = useGetGettyImages(
      searchQuery,
      selectedOrientationValue,
      false,
      15,
      1
    );

    useEffect(() => {
      if (isGettyImagesSuccess && gettyImages) {
        // Transform new images
        const newTransformedImages = gettyImages.map((image: any) => {
          const videoPreview = image.display_sizes.find(
            (displaySize: { name: string }) => displaySize.name === "preview_1"
          );
          const imagePreview = image.display_sizes.find(
            (displaySize: { name: string }) => displaySize.name === "thumb"
          );

          return {
            id: image.id,
            image_url: imagePreview?.uri || "",
            video_url: videoPreview?.uri || "",
            type: "image",
          };
        });

        // Keep previous images and append new ones, avoiding duplicates
        setTransformedGettyImages((prevImages) => {
          const existingIds = new Set(prevImages.map((image) => image.id));
          const filteredNewImages = newTransformedImages.filter(
            (image: any) => !existingIds.has(image.id)
          );
          return [...prevImages, ...filteredNewImages]; // Append new images
        });
      }
    }, [gettyImages, isGettyImagesSuccess]); // Add dependencies

    const { data: videosData, refetch: refetchVideos } = useGetAssets(
      videoPage,
      "video"
    );

    useEffect(() => {
      if (imageData && imageData.items && imageData.items.length > 0) {
        setImages([...images, ...imageData.items]);
      }
    }, [imageData]);
    useEffect(() => {
      if (videosData && videosData.items && videosData.items.length > 0) {
        const imageVideoData: any[] = videosData.items.filter(
          (obj: any) => obj.type !== "audio"
        );

        setVideos([...videos, ...imageVideoData]);
      }
    }, [videosData]);


    const scrollRef = useRef<HTMLDivElement>(null);

    const handleBottomReached = (tabType: string) => {
      if (activeTabKey === "0") {
        setGettyVideoPage((prev) => prev + 1);
      } else if (activeTabKey === "1") {
        setGettyPageNumber((prev) => prev + 1);
        // handleGettyImageLoadMore()
      } else if (activeTabKey === "4") {
        aRolefetchNextPage()
      } 

    };
    const baseStyle: React.CSSProperties = {
      height: "100%",
      backgroundColor: "white",
      padding: "12px 0",
      display: "flex",
      flexDirection: "column"
    };
    useEffect(() => {
      if (activeTabKey === "0") {
        setTransformedGettyImageVideos([]);
      } else if (activeTabKey === "1") {
        setTransformedGettyImages([]);
      }
    }, [selectedOrientationValue]);
    return (
      <div className="video-panel" style={baseStyle}>
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "8px 17px 8px 0",
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1
        }}>
          {isNotPanel === true && (
            <BlueprintButton
              style={{
                border: "none",
                boxShadow: "none",
                padding: "6px",
                minWidth: "32px",
                height: "32px",
                backgroundColor: "var(--color-surface)",
                borderRadius: "6px"
              }}
              icon="undo"
              onClick={() => {
                if (searchQueryIndex === searchQueries.length - 1) {
                  setSearchQueryIndex(0);
                } else {
                  setSearchQueryIndex(searchQueryIndex + 1);
                }
                setSearchQuery(searchQueries[searchQueryIndex]);
              }}
            />
          )}
        </div>

        {activeTabKey === "3" ? (
          <div style={{ padding: "0px 12px" }}>
            <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
              <Input
                placeholder="Search for AI Image"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                disabled={aiImageGenerating}
              />
              <Button
                onClick={() => generateAiImage()}
                disabled={aiImageGenerating}
                loading={aiImageGenerating}
                style={{
                  background: "var(--color-surface)",
                  borderColor: "var(--color-primary-200)",
                  color: "var(--color-primary-700)",
                  fontWeight: 500,
                  height: "32px",
                  padding: "0 16px"
                }}
              >
                Generate
              </Button>
            </div>
            <Collapse ghost>
              <Panel header="Prefix for AI Image generation" key="1">
                <TextArea
                  placeholder="Enter prefix for AI image generation"
                  value={userDetails?.purpose?.aiImagePrefix}
                  onChange={(e) => {
                    setUserDetails((prevDetails: any) => ({
                      ...prevDetails,
                      purpose: {
                        ...prevDetails?.purpose,
                        aiImagePrefix: e.target.value,
                      },
                    }));
                  }}
                  disabled={aiImageGenerating}
                  style={{ borderRadius: "6px" }}
                />
              </Panel>
            </Collapse>
          </div>
        ) : (
          <div style={{ padding: "0 12px", marginBottom: "16px" }}>
            <Input
              placeholder="Search for videos"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (activeTabKey === "0") {
                  setTransformedGettyImageVideos([]);
                } else if (activeTabKey === "1") {
                  setTransformedGettyImages([]);
                }
              }}
            />
          </div>
        )}

        <Tabs 
          defaultActiveKey="4" 
          onChange={handleTabChange}
          size="small"
        >
          {IS_FREE_PLATFORM === "true" && (
            <TabPane tab="Getty Images" key="0">
              <VideoSearch
                transformedElementsArray={transformedGettyImages}
                isLoading={isGettyImagesLoading}
                store={store}
                title={""}
                elementID={activeElementId}
                isNotPanel={isNotPanel}
                isGettyImage={true}
                dropDownValue={selectedOrientationValue}
                setSelectedValue={setSelectedOrientationValue}
                onBottomReached={handleBottomReached}
              />
            </TabPane>
          )}
          {IS_FREE_PLATFORM === "false" && (
            <>
              <TabPane 
                tab={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <VideoCameraAddOutlined style={{ fontSize: '14px' }} />
                    Videos
                  </span>
                } 
                key="0"
              >
                <VideoSearch
                  transformedElementsArray={transformedGettyImageVideos}
                  isLoading={isGettyImageVideoLoading}
                  store={store}
                  title={""}
                  elementID={activeElementId}
                  isGettyImage={true}
                  dropDownValue={selectedOrientationValue}
                  setSelectedValue={setSelectedOrientationValue}
                  isNotPanel={isNotPanel}
                  index={index}
                  ref={scrollRef}
                  onBottomReached={handleBottomReached}
                />
              </TabPane>

              <TabPane 
                tab={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <img 
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxyZWN0IHg9IjMiIHk9IjMiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjIiIHJ5PSIyIj48L3JlY3Q+PGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSIxLjUiPjwvY2lyY2xlPjxwb2x5bGluZSBwb2ludHM9IjIxIDE1IDE2IDEwIDUgMjEiPjwvcG9seWxpbmU+PC9zdmc+" 
                      alt="Images"
                      style={{ width: '14px', height: '14px' }}
                    />
                    Images
                  </span>
                } 
                key="1"
              >
                <VideoSearch
                  transformedElementsArray={transformedGettyImages}
                  isLoading={isGettyImagesLoading}
                  store={store}
                  title={""}
                  elementID={activeElementId}
                  isNotPanel={isNotPanel}
                  isGettyImage={true}
                  dropDownValue={selectedOrientationValue}
                  setSelectedValue={setSelectedOrientationValue}
                  onBottomReached={handleBottomReached}
                />
              </TabPane>

              <TabPane 
                tab={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <img 
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0xMiAyMnM4LTQgOC0xMFY1bC04LTMtOCAzdjdjMCA2IDggMTAgOCAxMHoiPjwvcGF0aD48L3N2Zz4=" 
                      alt="AI"
                      style={{ width: '14px', height: '14px' }}
                    />
                    AI
                  </span>
                } 
                key="3"
              >
                <VideoSearch
                  transformedElementsArray={transformedAIImage}
                  isLoading={aiImageGenerating}
                  store={store}
                  title={""}
                  elementID={activeElementId}
                  isNotPanel={isNotPanel}
                  index={index}
                  dropDownValue={selectedOrientationValue}
                  setSelectedValue={setSelectedOrientationValue}
                  onBottomReached={handleBottomReached}
                />
              </TabPane>

              <TabPane 
                tab={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <img 
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0yMCAxNGgtN20tNyAwSDNtMTggNGgtNG0tMTEgMEgzbTE1LThhMiAyIDAgMCAwLTItMkgzIi8+PHBhdGggZD0iTTMgMjBhMiAyIDAgMCAwIDIgMmgxNGEyIDIgMCAwIDAgMi0yVjhhMiAyIDAgMCAwLTItMkgzIi8+PC9zdmc+" 
                      alt="Assets"
                      style={{ width: '14px', height: '14px' }}
                    />
                    Assets
                  </span>
                } 
                key="4"
              >
                <div style={{ padding: "0 12px" }}>
                  <div style={{ display: "flex", gap: "12px", padding: "8px" }}>
                    <Button
                      icon={<UploadOutlined />}
                      className={`upload-button ${isUploading || uploadingVideo ? 'loading' : ''}`}
                      style={{ flex: 1 }}
                      loading={isUploading || uploadingVideo}
                      onClick={() => {
                        document.getElementById("input-file")?.click();
                      }}
                    >
                      {progress ? `${progress}%` : 'Upload Asset'}
                    </Button>

                    <Select
                      style={{
                        width: "120px",
                      }}
                      placeholder="Type"
                      optionFilterProp="children"
                      onChange={(value:any)=>setType(value)}
                      value={type.toUpperCase()}
                    >
                      {['image', 'video'].map((data, index) => (
                        <Select.Option key={index} value={data.toUpperCase()}>
                          {data.charAt(0).toUpperCase() + data.slice(1)}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>

                  <input
                    type="file"
                    id="input-file"
                    style={{ display: "none" }}
                    onChange={handleFileInput}
                    accept="image/*, video/*, .mkv"
                    multiple
                  />

                  <VideoSearch
                    transformedElementsArray={transformedVideos}
                    isLoading={isImagesLoading}
                    store={store}
                    title={""}
                    elementID={activeElementId}
                    index={index}
                    onBottomReached={handleBottomReached}
                  />
                </div>
              </TabPane>

              <TabPane 
                tab={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <img 
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Im0xNSA5LTYgNm02IDBoLTZtNy0zYTkgOSAwIDEgMS0xOCAwIDkgOSAwIDAgMSAxOCAweiI+PC9wYXRoPjwvc3ZnPg==" 
                      alt="Website"
                      style={{ width: '14px', height: '14px' }}
                    />
                    Website
                  </span>
                } 
                key="5"
              >
                <div style={{ padding: "0 12px" }}>
                  <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
                    <Input
                      placeholder="Enter website URL"
                      value={websiteUrl}
                      onChange={(e) => setWebsiteUrl(e.target.value)}
                      disabled={isWebsiteFetching}
                    />
                    <Button
                      onClick={fetchWebsiteAssets}
                      disabled={isWebsiteFetching || !websiteUrl.trim()}
                      loading={isWebsiteFetching}
                      style={{
                        background: "var(--color-surface)",
                        borderColor: "var(--color-primary-200)",
                        color: "var(--color-primary-700)",
                        fontWeight: 500,
                        height: "32px",
                        padding: "0 16px"
                      }}
                    >
                      Fetch
                    </Button>
                  </div>

                  <VideoSearch
                    transformedElementsArray={transformedWebsiteAssets}
                    isLoading={isWebsiteFetching}
                    store={store}
                    title={""}
                    elementID={activeElementId}
                    isNotPanel={isNotPanel}
                    index={index}
                    dropDownValue={selectedOrientationValue}
                    setSelectedValue={setSelectedOrientationValue}
                    onBottomReached={handleBottomReached}
                  />
                </div>
              </TabPane>
            </>
          )}
        </Tabs>
      </div>
    );
  }
);

// define the new custom section
export const CustomVideoSearchTwo = {
  name: "video-editor",
  Tab: (props: any) => {
    return (
      <SectionTab
        name={IS_FREE_PLATFORM === "true" ? "Image Search" : "Media"}
        {...props}
      >
        <Video02Icon />
      </SectionTab>
    );
  },
  Panel: VideoPanel,
};

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Set debouncedValue to value after the specified delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup function to clear the timeout if value or delay changes
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Only re-call effect if value or delay changes

  return debouncedValue;
}
